import request from "@utils/request";

export function getDataProfitTaker(query) {
    return request({
        url: 'alert/data/profit-taker',
        method: 'get',
        params: query
    })
}
